
import { defineComponent } from 'vue';
import { UserOutlined } from '@ant-design/icons-vue';
import { useHeaderPart } from './hooks/useHeaderPart';
import { isInHospEnv } from '../services/base.js';
export default defineComponent({
  name: 'HomeHeader',
  components: {
    UserOutlined
  },
  setup() {
    const { state, userMenuClick } = useHeaderPart();
    const isHenanBc = location.host.indexOf('henanbc') > -1 || false;
    const isNuwa = location.host.indexOf('nuwarwe.net') > -1 || false;
    return {
      state,
      userMenuClick,
      isInHospEnv,
      isHenanBc,
      isNuwa,
    };
  }
});
